import { t } from '../../i18n/idioma';

/** As regras da tela de entrada (e do cartão de login da landing aberta). O servidor revalida tudo. */
export const EMAIL_MIN = 5;
export const EMAIL_MAX = 254;
export const SENHA_MIN = 8;
export const SENHA_MAX = 128;

export function validarEmail(raw: string): string | null {
  const email = raw.trim();
  if (email.length < EMAIL_MIN || email.length > EMAIL_MAX) return t('auth.invalidEmail');
  const at = email.indexOf('@');
  if (at < 1 || at !== email.lastIndexOf('@') || at === email.length - 1) return t('auth.invalidEmail');
  if (email.includes(' ')) return t('auth.invalidEmail');
  return null;
}

export function validarSenha(password: string, email: string, cadastro: boolean): string | null {
  if (!cadastro) return password ? null : t('auth.passwordShort');
  if (password.length < SENHA_MIN) return t('auth.passwordShort');
  if (password.length > SENHA_MAX) return t('auth.passwordLong');
  if (password.toLowerCase() === email.trim().toLowerCase()) return t('auth.passwordIsEmail');
  return null;
}
